import React from 'react';

/**
 * Full-canvas loading placeholder for dashboards and reports, shown until the
 * view's visualisation + metric definitions ("the queries") resolve.
 *
 * Deliberately renders a plain, empty area — NOT a spinner and NOT an
 * approximate card grid. A spinner in the middle of the screen reads as
 * "blocked/working"; what we want during this phase is a calm, quiet wait. The
 * real card layout (with real titles) can only be drawn once definitions are
 * known — approximating it makes titles pop in and cards jump from approximated
 * positions to their real ones. So we hold the space quietly, then the real
 * canvas renders and each card shows its own skeleton while its data loads.
 *
 * `minHeight` reserves the canvas area so the surrounding chrome doesn't jump.
 */
const CanvasLoading = () => (
  <div data-testid="canvas-loading" style={{ minHeight: '70vh' }} />
);

export default CanvasLoading;
